export function loadGalleryLazyImage(img) {
    if (!img || img.getAttribute('src') || !img.dataset.splideLazy) {
        return;
    }

    const slide = img.closest('.splide__slide');
    const lazySrc = img.dataset.splideLazy;
    const lazySrcset = img.dataset.splideLazySrcset;
    const spinner = slide?.querySelector('.splide__spinner');

    slide?.classList.add('is-loading');

    const onDone = () => {
        slide?.classList.remove('is-loading');
        spinner?.remove();
        img.removeEventListener('load', onDone);
        img.removeEventListener('error', onDone);
    };

    img.addEventListener('load', onDone);
    img.addEventListener('error', onDone);

    img.src = lazySrc;

    if (lazySrcset) {
        img.srcset = lazySrcset;
    }

    delete img.dataset.splideLazy;
    delete img.dataset.splideLazySrcset;

    if (img.complete) {
        onDone();
    }
}

export function loadSlideLazyImages(splide, index) {
    const slide = splide.Components.Slides.getAt(index);

    if (slide) {
        slide.slide.querySelectorAll('img[data-splide-lazy]').forEach(loadGalleryLazyImage);
    }
}

export function loadVisibleSlides(splide, startIndex, visibleCount = 1, preloadAhead = 0) {
    const start = startIndex;
    const end = Math.min(start + visibleCount + preloadAhead, splide.length);

    for (let i = start; i < end; i++) {
        loadSlideLazyImages(splide, i);
    }
}

export function bindSplideLazyLoad(splide, visibleCount = 1, preloadAhead = 0) {
    const loadFrom = (index = splide.index) => {
        loadVisibleSlides(splide, index, visibleCount, preloadAhead);
    };

    // Initial visible slides only.
    loadFrom(splide.index);

    // Load the destination slide as soon as navigation starts (shows spinner, no preload of neighbors).
    splide.on('move', (newIndex) => {
        loadFrom(newIndex);
    });
}
